import { Button, Flex, Modal } from "antd";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CustomTitle } from "../../../../common/customTitle";
import { deleteCategoryByIdAction } from "../../../../../redux/services/categories/categoriesServices";
import { useTranslation } from "react-i18next";

const CategoriesDeleteDialog = ({ open, onClose }) => {
  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  const {t} = useTranslation();

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* id dependencies */
  const { selectedcategoryId } = useSelector((state) => state.categories);
  /* id dependencies */

  /* initial dependencies */
  useEffect(() => {
    if (
      !selectedcategoryId ||
      selectedcategoryId === "" ||
      selectedcategoryId === null ||
      selectedcategoryId === undefined
    ) {
      onClose();
    }
  }, [selectedcategoryId]);
  /* initial dependencies */

  /* perform delete action */
  const handleDelete = () => {
    if (
      selectedcategoryId &&
      selectedcategoryId !== "" &&
      selectedcategoryId !== null &&
      selectedcategoryId !== undefined
    ) {
      const dataToBeSent = {
        selectedcategoryId,
      };
      setLoading(true);
      dispatch(deleteCategoryByIdAction(dataToBeSent)).then(() => {
        onClose();
        setLoading(false);
      });
    }
  };
  /* perform delete action */

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={false}
      confirmLoading={loading}
    >
      <Flex vertical gap="3rem" align="center" justify="center">
        <CustomTitle textDecoration="underline" justifyContent="center">
          {t("Modules.Offer.OfferForm.deleteOffer")}
        </CustomTitle>
        <Title level={2}>{t("deleteTitle")}</Title>
        <Flex gap="1rem" align="center" justify="center">
          <Button type="primary" onClick={handleDelete}>
            {t("confirmationPopup.buttonYesText")}
          </Button>
          <Button type="default" onClick={onClose}>
          {t("confirmationPopup.buttonNoText")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default CategoriesDeleteDialog;
